<template>
  <div class="scrolling-container" v-if="dataItem.length > 0">
    <div v-if="theme == 'light' || theme == 'dark' || theme == 'medium'"></div>
    <button type='button' :class="`${pagination.currentPage == page ? 'page active': 'page'}`" v-for='page in pagination.pages' :key="page" @click="paginate(page)">{{page}}</button>
    <div :id="id"></div>
  </div>
  <div class="scrolling-container" v-else> 
      <h1 class="not-found">Data not found</h1>
  </div>
</template>

<script>
// Dependences
import store from "@/store";

import Highcharts from "highcharts";
import highchartsMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import Gantt from "highcharts/modules/gantt";

highchartsMore(Highcharts);
solidGauge(Highcharts);
Gantt(Highcharts);

export default {
  name: "Summary Chart",
  props: ["dataItem", "id"],
  data() {
    return {
      parsedData: [],
      pagedData: [],
      colorData: [],
      pagination: {
        currentPage:1,
        pages: 1,
        recordsFrom: 0,
        recordsTo: 19, // max records show minus 1
        pageBreak: 20 // Replace this with the max required data to be displayed on the page
      }
    };
  },
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    
  },
  updated() {
    if(this.dataItem.length > 0) {
      this.renderChart();
    }
  },

  mounted() {
    // var binder = this;
    // setTimeout(function(){
    //   binder.pagination.pages = Math.ceil(binder.dataItem.length / binder.pagination.pageBreak);
    //   binder.parseIncomingData();
    //   if(binder.dataItem.length > 0) {
    //   binder.renderChart();
    //   }
    // },100)
    
    if(this.dataItem.length > 0) {
      this.renderChart();
    }
  },

  methods: {
    paginate(page) {
      this.pagination.currentPage = page;
      let from = ((page * this.pagination.pageBreak) - this.pagination.pageBreak) -1;
      let to = (page * this.pagination.pageBreak) - 1;
      let arrayLength = this.parsedData.length;
      this.pagination.recordsFrom = (page == 1) ? 0 : from; // 1=> 0, 2=> 199, 3=> 399
      this.pagination.recordsTo = to >= arrayLength ? (arrayLength - from) + from: to;  // 1=> 199, 2=> 399, 3=> 599
      this.renderChart();
    },
    parseIncomingData() {
       this.dataItem.map((item, index) => {
        this.parsedData.push({
          start: Date.UTC(
            new Date(item.ProjectStartDate).getFullYear(),
            new Date(item.ProjectStartDate).getMonth() + 1,
            new Date(item.ProjectStartDate).getDate()
          ),
          end: Date.UTC(
            new Date(item.ProjectFinishDate).getFullYear(),
            new Date(item.ProjectFinishDate).getMonth() + 1,
            new Date(item.ProjectFinishDate).getDate()
          ),
          name: `<a style="color: #fff;text-decoration:none;" href="/#/project-ar?id=${item.ProjectUID}">${item.ProjectName}</a>`,
          assignee: item.ProjectManager,
          y: index,
        });
      });

      this.dataItem.map((item) => {
        let fillColor = "";
        if (item.ProjectStatus == "تم الاطلاق(مكتمل)") {
          fillColor = "#3ABDCB";
        }
        if (item.ProjectStatus == "حسب المخطط") {
          fillColor = "#71C370";
        }
        if (item.ProjectStatus == "متوقع التأخير/ملاحظة مهمة") {
          fillColor = "#FEAF4D";
        }
        if (item.ProjectStatus == "متأخر") {
          fillColor = "#F26A3F";
        }
        this.colorData.push(fillColor);
      });



    },  
    renderChart: function () {
      // console.log(this.parsedData);
      this.pagination.pages = Math.ceil(this.dataItem.length / this.pagination.pageBreak);
      this.parseIncomingData();
      this.pagedData = this.parsedData.slice(this.pagination.recordsFrom,this.pagination.recordsTo);
      this.pagedData.map((item,index)=> {
         item.y = index;
      });
      Highcharts.ganttChart("container", {
        chart: {
          scrollablePlotArea: {},
          backgroundColor:
            this.theme == "medium"
              ? ""
              : this.theme == "light"
              ? "#F3F3F3"
              : "transparent",
        },

        title: {
          text: "Executive Summary",
          useHTML: true,
          style: {
            color: "transparent",
          },
        },

        lang: {
          accessibility: {
            axis: {
              xAxisDescriptionPlural:
                "The chart has a two-part X axis showing time in both week numbers and days.",
              yAxisDescriptionSingular:
                "The chart has a tabular Y axis showing a data table row for each point.",
            },
          },
        },

        accessibility: {
          point: {
            descriptionFormatter: function (point) {
              return Highcharts.format(
                point.milestone
                  ? "{point.name}, milestone for {point.assignee} at {point.x:%Y-%m-%d}."
                  : "{point.name}, assigned to {point.assignee} from {point.x:%Y-%m-%d} to {point.x2:%Y-%m-%d}.",
                { point }
              );
            },
          },
        },

        credits: {
          enabled: false,
        },

        xAxis: {
          tickPixelInterval: 70,
        },

        yAxis: {
          type: "category",
          grid: {
            enabled: true,
            borderColor:
              this.theme == "medium"
                ? "#89A1A6"
                : this.theme == "light"
                ? "#DDDDDD"
                : "#315067 ",
            borderWidth: 1,
            columns: [
              {
                title: {
                  text: "اسم المشروع",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
                labels: {
                  format: "{point.name}",
                  useHTML: true,
                  style: {
                    whiteSpace: "nowrap",
                    width: 200,
                    textOverflow: "ellipsis",
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
              },
              {
                title: {
                  text: "مدير المشروع",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
                labels: {
                  format: "{point.assignee}",
                  style: {
                    whiteSpace: "nowrap",
                    width: 200,
                    textOverflow: "ellipsis",
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
              },
              // {
              //   title: {
              //     text: "Est. days",
              //     style: {
              //       color: this.theme == "medium"
              //           ? "#fff"
              //           : this.theme == "light"
              //           ? "#103C64"
              //           : "#EAF6FF",
              //     },
              //   },
              //   labels: {
              //     formatter: function () {
              //       var point = this.point,
              //         days = 1000 * 60 * 60 * 24,
              //         number = (point.x2 - point.x) / days;
              //       return Math.round(number * 100) / 100;
              //     },
              //     style: {
              //       color: this.theme == "medium"
              //           ? "#fff"
              //           : this.theme == "light"
              //           ? "#103C64"
              //           : "#EAF6FF",
              //     },
              //   },
              // },
              {
                labels: {
                  format: "{point.start:%e. %b. %Y}",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
                title: {
                  text: "تاريخ البدء",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
              },
              {
                title: {
                  text: "تاريخ الإنهاء",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
                offset: 50,
                labels: {
                  format: "{point.end:%e. %b. %Y}",
                  style: {
                    color:
                      this.theme == "medium"
                        ? "#fff"
                        : this.theme == "light"
                        ? "#103C64"
                        : "#EAF6FF",
                  },
                },
              },
            ],
          },
          gridLineColor:
            this.theme == "medium"
              ? "#89A1A6"
              : this.theme == "light"
              ? "#DDDDDD"
              : "#315067",
        },

        tooltip: {
          xDateFormat: "%e %b %Y, %H:%M",
        },
        rangeSelector: {
          enabled: true,
          selected: 6,
          
        },
        series: [
          {
            // type: "gantt",
            name: "Executive Summary",
            data: this.pagedData,
            colors: this.colorData,
            // turboThreshold: 0
            // turboThreshold: 1000000	
          },
        ],

        

        // exporting: {
        //   sourceWidth: 1000,
        // },
      });
    },
  },
};
</script>



<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.scrolling-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  #container {
    min-height: 'auto';
  }

  .not-found{
    text-align: center;
    color: white;
  }
}
.page.active {
  background: blue;
}
</style>